import React, { useEffect, useState } from 'react';

import PageTitle from '../../Components/PageTitle';
import images from '../../assets/images/verticless.jpg';
import ContentController from '../../apis/controller/content.controller';
import { renderImage } from '../../Components/helper/image';

function Verticals() {
    const [verticall, setVerticalls] = useState();
    const [breadCrumbs, setBreadcrumbs] = useState();
    const [loader, setLoader] = useState(false);

    useEffect(() => {
        getPartners();
        window.scrollTo(0, 0);
    }, []);

    const getPartners = async () => {
        setLoader(true);
        let res = await new ContentController().verticals();
        if (res && res.status) {
            setVerticalls(res.page);
            setBreadcrumbs(res.breadcrumb);
        }
        setLoader(false);
    };
    return (
        <>
            {breadCrumbs ? <PageTitle title={breadCrumbs.main_title} image={breadCrumbs.image} /> : null}
            {verticall && <section className="second-level-section">
                <div className="container">
                    <div className="row">
                        <div className='col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12'>
                            <div className="left-box tick-icon-list text-center">
                                <h1>{verticall.title}</h1>
                                <h2>{verticall.sub_title}</h2>
                                <p>{verticall.description}</p>
                            </div>
                        </div>
                        <div className='col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12'>
                            <div className='vertis_set'>
                                <div className='row'>
                                    <div className='col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12'>
                                        <div className="left-box tick-icon-list">
                                            <h1>Software Development &  <span>Engineering Services </span></h1>
                                            <p>We deliver robust, scalable, and reliable software product solutions to clients across the globe driven by the top 1% of software engineering talent in India  </p>
                                            <div className='vertils_img'>
                                                <img src={renderImage(verticall.image,'large')} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12'>
                                        {verticall.feature.map((item, index) => (
                                            <div key={index} className='feature'>
                                                <h2>
                                                    {item.title}
                                                </h2>
                                                <p>
                                                    {item.description}
                                                </p>

                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>}
        </>
    );
}

export default Verticals;
